import React, { useState, useMemo } from 'react';
import { ChildrenPropType } from '../../../prop-types/children';
import { useRouteMatch } from 'react-router-dom';
import { FEATURE_ROUTE_SCAN } from '../../../components/app-header/constants/routes';
import { useBarcodeScanningFeatureGate } from '../../../feature-gates/use-barcode-scanning-feature-gate';

export const ScanToViewContext = React.createContext({});

// Scan to View
export const ScanToViewContextProvider = ({ children }) => {
  const scanPageMatch = useRouteMatch(FEATURE_ROUTE_SCAN);
  const [shouldMountGlobalHotkey, setShouldMountGlobalHotkey] = useState(true);
  const { isFeatureEnabled } = useBarcodeScanningFeatureGate(); // @design-input-pending

  const value = useMemo(
    () => ({
      setShouldMountGlobalHotkey,
      shouldMountGlobalHotkey: isFeatureEnabled && !scanPageMatch && shouldMountGlobalHotkey,
    }),
    [isFeatureEnabled, scanPageMatch, shouldMountGlobalHotkey],
  );

  return <ScanToViewContext.Provider value={value}>{children}</ScanToViewContext.Provider>;
};

ScanToViewContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
